function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.566 2.175l.098.078 9 8c.413.367.45.999.083 1.411-.338.381-.903.442-1.312.16l-.1-.077L20 11.45V21c0 .513-.386.936-.883.993L19 22H5c-.513 0-.936-.386-.993-.883L4 21v-9.552l-.336.3c-.38.338-.949.332-1.322.005l-.09-.089c-.338-.38-.332-.949-.005-1.322l.089-.09 9-8c.347-.308.856-.334 1.23-.077zM12 4.338L6 9.671V20h12V9.671l-6-5.333z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondaryPath",
  d: "M12 7L16 10.594 8 10.594z"
}));

var SvgHomeCustom = function SvgHomeCustom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeCustom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-custom.fcec6cea.svg";
export { ForwardRef as ReactComponent };